import repository from "../Repository";

export default {
  list(screenId) {
    return repository.post(
      `lodine_distribution`,
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
